<div>
    @if (fieldData().readonly) {
        <cipo-text-view [value]="control().value" [config]="fieldData()" />
    } @else {
        <cipo-outline-field
            [label]="fieldData().label"
            [markChanged]="fieldData().markChanged && valueChanged()"
            [required]="fieldData().required"
            [error]="control().touched && control().invalid">
            <div fxLayout fxLayoutAlign="space-between center" class="cipo--width--full">
                <mat-chip-listbox
                    class="mat-mdc-chip-set-stacked cipo--overflow--auto"
                    [style.maxHeight]="maxHeight()"
                    [disabled]="fieldData().disabled"
                    [attr.aria-label]="fieldData().label | translate"
                    (change)="selectionChanged($event)"
                    fxLayout="row wrap"
                    [multiple]="fieldData().multiple">
                    @for (item of deepFieldData.options(); track item.key) {
                        <mat-chip-option
                            [fxFlex.gt-sm]="100 / fieldData().columns - 2"
                            [fxFlex.lt-md]="100"
                            [value]="item.key"
                            [disabled]="item.isDisabled"
                            [title]="item.value | translate"
                            [selected]="control().value?.includes(item.key)"
                            [attr.data-testid]="fieldData().testId ? fieldData().testId + '-' + item.key : null"
                            togglePosition="before">
                            {{ item.value | translate }}
                        </mat-chip-option>
                    }
                </mat-chip-listbox>

                @if (fieldData().fieldDescription) {
                    <mat-icon
                        class="material-icons-outlined cipo--cursor--help"
                        [title]="fieldData().fieldDescription | translate">
                        info
                    </mat-icon>
                }
            </div>
        </cipo-outline-field>

        @if (control().touched && control().invalid) {
            <p class="cipo-field-subscript cipo-text--warn-900">
                {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
            </p>
        } @else if (fieldData().hint) {
            <p class="cipo-field-subscript">{{ fieldData().hint | translate }}</p>
        }
    }
</div>
